/* eslint react/forbid-prop-types: 0 */
import React from "react";
import PropTypes from "prop-types";
import CreateLocation from "./CreateLocation";
import EditLocation from "./EditLocation";

const LocationSelect = props => {
  if (props.location.id) {
    return <EditLocation {...props} />;
  }

  return <CreateLocation {...props} />;
};
LocationSelect.propTypes = {
  location: PropTypes.object.isRequired
};

export default LocationSelect;



// WEBPACK FOOTER //
// ./src/forms/fields/LocationSelect.js